import * as oidc from 'oidc-client'

export const getUserManager = () => {
    if (!(window as any)._userManager) {
        (window as any)._userManager = new oidc.UserManager({
            authority: process.env.REACT_APP_LISMA_IGNITION_AUTHORITY,
            client_id: process.env.REACT_APP_LISMA_IGNITION_CLIENT_ID,
            redirect_uri: window.location.protocol + "//" + window.location.host + "/signin",
            //redirect_uri: process.env.REACT_APP_LISMA_IGNITION_REDIRECT_URI,
            response_type: 'id_token token',
            scope: process.env.REACT_APP_LISMA_IGNITION_SCOPE,
            loadUserInfo: true,
            post_logout_redirect_uri: "http://localhost:3000/",
        })
    }
    return (window as any)._userManager
}

